
<template>
  <div>
    <Grid
      :service="service"
      route_name="due-diligence-form"
      :ref="'grid'"
      route_grid_path="due-diligence/grid"
      order_column="created_at"
      direction="desc"
    >
      <template v-slot:actions="actions">
        <div class="flex flex-row gap-2">
          <feather-icon
            v-permission="'due_diligence_form.download.pdf'"
            v-if="hasReportUrl(actions.row)"
            icon="DownloadIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-green"
            v-tooltip.top="{
              content: 'Baixar PDF',
              delay: { show: 100, hide: 100 }
            }"
            @click="downloadPDF(actions.row)"/>
            <feather-icon
              v-permission="'due_diligence_form.process_pdf'"
              v-if="actions.row && !hasReportUrl(actions.row)"
              icon="CheckIcon"
              class="h-5 w-5 mb-1 mr-1 stroke-current text-green"
              v-tooltip.top="{
                content: 'Gerar PDF',
                delay: { show: 100, hide: 100 }
              }"
              @click="gerarPDF(actions.row.id)"/>
            <feather-icon
              v-permission="'due_diligence_form.reprocess_pdf'"
              v-if="hasReportUrl(actions.row)"
              icon="CheckIcon"
              class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
              v-tooltip.top="{
                content: 'Gerar PDF Novamente',
                delay: { show: 100, hide: 100 }
              }"
              @click="reprocessPDF(actions.row.id)"/>
          <feather-icon
            v-permission="'due_diligence_form.show'"
            icon="EyeIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
            v-tooltip.top="{
              content: 'Detalhar formulário',
              delay: { show: 100, hide: 100 }
            }"
            @click="detail(actions.row.id)"/>
        </div>
      </template>
    </Grid>
  </div>
</template>


<script>
import { BButton } from 'bootstrap-vue'

import FormManagementService from '@/services/api/form/FormManagementService'

export default {
  directives: {
  },
  components: {
    BButton,
  },
  data: () => ({
    service: null
  }),
  methods: {
    hasReportUrl(row) {
      const reportUrl = this._.get(row, 'report_url')
      return (
        typeof reportUrl === 'string' &&
        reportUrl.trim() !== ''
      )
    },
    detail(id) {
      this.$router.push(`/due-diligence-form/${id}`)
    },
    downloadPDF(model) {
      const report = this._.get(model, 'report_url')
      if (report) {
        this.$utils.browser.newTab(report)
      }
    },
    gerarPDF(formId) {
      this.$vs.loading()
      this.service.generateAndSendMail('due-diligence', formId).then(
        response => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          this.updateGrid();
        },
        error => {
          this.notifyWarning(this.$vs, this.$t('messages.error'))
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },
    reprocessPDF(formId) {
      this.$vs.loading()
      this.service.reprocessPdf('due-diligence', formId).then(
        response => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          this.updateGrid();
        },
        error => {
          this.notifyWarning(this.$vs, this.$t('messages.error'))
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },
    updateGrid(){
      const grid = this.$refs['grid']
      if (grid) {
       grid.fetchGridData()
      }
    },
  },
  beforeMount() {
    console.log('coin for your witcher')
    this.service = FormManagementService.build(this.$vs)
  }
}
</script>
